export const PrintedText = [
  "Легенда на паркете — набор в группу открыт!",
  "Хочешь двигаться как BANDANA? Записывайся в команду!",
  "Твой бит, твой стиль — приходи на хип-хоп!",
  "С улицы — на сцену. Набор в группу по хип-хопу!",
  "Будь первым на танцполе — не упусти шанс!",
  "От новичка до чемпиона — прокачай скилл с BANDANA!",
  "Встань в строй лучших — набор в хип-хоп команду уже идёт!",
  "Сцена ждёт именно тебя — кастинг открыт!",
  "Не просто танцуй — живи в ритме хип-хопа!",
  "Хватит смотреть — пора танцевать! Вступай в команду BANDANA!",
];
